import { Component, inject } from '@angular/core';
import { LocalizedUrlService } from '../../../core/services/localized-url.service';

@Component({
  selector: 'app-contact-page',
  template: `
    <app-page-section padding="sm">
      <div class="relative rounded-3xl px-4 py-14 sm:px-8 sm:py-16 lg:px-14 lg:py-16 overflow-hidden" style="background: linear-gradient(to bottom, #f5f7f9 0%, #fafbfc 50%, #ffffff 100%)">
      <div class="sm:text-center">
        <h1 class="text-balance">{{ 'contact.intro.title' | transloco }}</h1>
        <p class="mt-6 text-pretty max-w-xl sm:mx-auto">{{ 'contact.intro.description' | transloco }}</p>
      </div>

      <div class="mt-12 grid grid-cols-1 gap-16 md:grid-cols-2 md:max-w-[70%] mx-auto">
        <app-public-info-card icon="magnifying-glass" variant="ghost">
          <span title [innerHTML]="'contact.room-question.title' | transloco"></span>
          <span description>{{ 'contact.room-question.description' | transloco }}</span>
          <div footer>
            <a [routerLink]="localizedUrl.link('search')">
              <app-button variant="outlined">{{ 'contact.room-question.button' | transloco }}</app-button>
            </a>
          </div>
        </app-public-info-card>

        <app-public-info-card icon="laptop" variant="ghost">
          <span title>{{ 'contact.owner.title' | transloco }}</span>
          <span description>{{ 'contact.owner.description' | transloco }}</span>
          <div footer class="flex flex-wrap items-center gap-2 text-sm text-gray-600">
            <a class="no-underline text-gray-600" href="mailto:contact@ercos.ch">contact&#64;ercos.ch</a>
            <span class="text-gray-300">|</span>
            <a class="no-underline text-gray-600" href="tel:0215253060">021 525 30 60</a>
            <span class="text-gray-300">|</span>
            <a class="no-underline text-gray-600" href="https://www.ercos.ch" target="_blank">ercos.ch</a>
          </div>
        </app-public-info-card>
      </div>
      </div>
    </app-page-section>

    <app-page-section>
      <h2 class="text-center">{{ 'contact.more.title' | transloco }}</h2>

      <div
        class="mx-auto mt-20 grid w-full grid-cols-1 gap-12 sm:w-3/4 lg:w-full lg:grid-cols-2 lg:gap-16"
      >
        <app-contact-card
          [badgeText]="'contact.more.create-account.badge' | transloco"
          [title]="'contact.more.create-account.title' | transloco"
          image="creer-compte.webp"
          [link]="localizedUrl.link('becomeHost')"
        ></app-contact-card>

        <app-contact-card
          [badgeText]="'contact.more.directory.badge' | transloco"
          [title]="'contact.more.directory.title' | transloco"
          image="annuaire.webp"
          [link]="localizedUrl.link('search')"
        ></app-contact-card>
      </div>
    </app-page-section>
  `,
  styles: ``,
  standalone: false,
})
export class ContactPageComponent {
  protected localizedUrl = inject(LocalizedUrlService);
}
